import React, { memo } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { Typography } from '../../material-ui/Typography';
import { Panel } from '../../Panel/Panel';
import { SummaryCrewTaskInfo } from '../SummaryCrewTaskInfo/SummaryCrewTaskInfo';
import { SummaryCrewLegInfo } from '../SummaryCrewLegInfo/SummaryCrewLegInfo';
import { CrewTypes } from '../../../service/constants';
import { getTimeFormat } from '../../../service/NavPointsUtils';
import { getTranslateText } from '../../../service/utils';
import { getDataFormat, summaryFields } from './tools';
import { useStyles } from './useStyles';

export const SummaryBufferCrew = memo((props) => {
    const { crew = {}, declaration = {} } = props;
    const { legs, total = {}, previousTasks } = crew;
    const classes = useStyles();
    const { t: translate } = useTranslation();
    if (!crew) {
        return;
    }
    const fullName = getTranslateText('fullName', crew);
    const chair = getTranslateText('chair', total);

    let rowIndex = 0;

    return (
        <Panel
            toolbarClassName={crew.total.crewType === CrewTypes.PCT_CABINSTAFF ? classes.cabinToolbar : classes.salonToolbar}
            className={classes.panel}
            customToolbar={
                <Typography className={classes.toolbar}>{`${crew.tableNumber || ''}  ${fullName || ''}  ${chair || ''}`}</Typography>
            }
        >
            <table className={classes.table}>
                <thead>
                    <tr className={classes.header}>
                        <th className={classnames(classes.headerCell, classes.flight)}>{translate('summaryTaskPage.flight')}</th>
                        {summaryFields.map(
                            ({ id, title }, index) =>
                                declaration[id] && (
                                    <th key={index} className={classnames(classes.headerCell, id === 'pf' && classes.pf)}>
                                        {translate(title)}
                                    </th>
                                )
                        )}
                    </tr>
                </thead>
                <tbody>
                    {previousTasks &&
                        previousTasks.map((previousTask, index) => {
                            rowIndex = index;
                            return (
                                <SummaryCrewTaskInfo
                                    previousTask={previousTask}
                                    key={index}
                                    number={rowIndex}
                                    declaration={declaration}
                                    fields={summaryFields}
                                />
                            );
                        })}
                    {(() => {
                        rowIndex += previousTasks.length > 0 ? 1 : 0;
                    })()}
                    {legs &&
                        legs.map((leg, index) => {
                            rowIndex += index;
                            return (
                                <SummaryCrewLegInfo
                                    leg={leg}
                                    key={index}
                                    number={rowIndex}
                                    lastLeg={legs.length - 1}
                                    declaration={declaration}
                                    fields={summaryFields}
                                    getDataFormat={getDataFormat}
                                />
                            );
                        })}
                </tbody>
                <tfoot>
                    <tr className={classes.tableFoot}>
                        <td>{translate('summaryTaskPage.total')}:</td>
                        {summaryFields.map(
                            ({ id, format, totalFormat }, index) =>
                                declaration[id] && (
                                    <td key={index}>
                                        {(id === 'work' && getTimeFormat(total[id] + (total.previousWork || 0))) ||
                                            getDataFormat(id, totalFormat || format, total)}
                                    </td>
                                )
                        )}
                    </tr>
                </tfoot>
            </table>
        </Panel>
    );
});
